module.exports = __webpack_public_path__ + "static/media/sas-sdis32.a0a9e3a7.png";